/*
 * @Author: Yumeng Xue
 * @Date: 2026-01-03
 * @Description: Cluster type definition for extracted line clusters
 * @FilePath: /topo-mess/src/types/cluster.ts
 */

export interface Cluster {
    id: string; // UUID
    lineIds: number[]; // 该聚类包含的线条ID
    thumbnail: string; // 缩略图 DataURL (PNG/JPEG)
    count: number; // 线条数量
    createdAt: number; // 创建时间戳
}

/**
 * Generate a UUID v4
 */
export function generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
}
